// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3VdJN","header":"ReportDetails_header__1cVnd","title":"ReportDetails_title__1DbQC","left":"ReportDetails_left__1aM4X"};